import React, { useState, useEffect } from "react";
import "./dashbord.css";
import { CgSoftwareDownload } from "react-icons/cg";
import CreateCategory from "../view-transaction/view-transaction.tsx";
import { IoEyeOutline, IoRefresh } from "react-icons/io5";
import { environment } from "../../../environment/enviroment.js";
import toast from "react-hot-toast";
import {
  getALLevent,
  getEventDetails,
  getPartiDetails,
  geteventVolume,
  getDetailsById,
  getEventS,
  download,
  getNotifiesDetails,
  downloadNotifyReport,
  getTickent,
} from "../../../_services/dashboard.js";
import ReusableTable from "../../../components/reUsableTable/reUsableTable.tsx";
import EmptyState from "../../../components/emptyState/emptyState.tsx";
import SearchableEventSelect from "../../../components/searchableEventSelect/searchableEventSelect.tsx";

interface Ticket {
  id: number;
  ticket_name: string;
  total_tickets: string;
  remaining_tickets: string;
  ticket_amount: string;
  ticket_visualize_amount: string;
  ticket_description: string;
  is_free_ticket: number;
  is_delete?: boolean;
  is_active?: boolean;
  is_sold_out?: boolean;
}

interface Participant {
  customer_email: string;
  customer_name: string;
  is_refund: boolean;
  is_refund_init?: boolean;
  is_refund_rejected?: boolean;
  is_refund_request_approved?: boolean;
  refund_request_status?: string;
  [key: string]: any;
}

function Dashbord() {
  var filterParams: any = {};
  const [dataCount, setDataCount] = useState(0);
  // var tablePageIndex = 1;
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [partData, setPartData] = useState<Participant[]>([]);
  const [notifies, setNotifies] = useState<Participant[]>([]);
  const [event, setData] = useState<any[]>([]);
  const [tStatus, setTicketStatus] = useState<any>();
  const [defaultEventId, setDefaultEventId] = useState("");
  const [eventData, setEventData] = useState<any>(null);
  const [eventId, setId] = useState(defaultEventId);

  const [volume, setVolume] = useState<any>(null);
  const [tickets, setEventDetails] = useState<Ticket[]>([]);
  const [modalData, setModalData] = useState(null);
  const [isCategoryCreateOffCanvasOpen, setIsCategoryCreateOffCanvasOpen] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [dataType, setDataType] = useState("participants");
  const [searchText, setSearchText] = useState("");

  const [venues, setVenues] = useState<any[]>([]);
  const [selectedVenueIndex, setSelectedVenueIndex] = useState(0);
  const [selectedDayIndex, setSelectedDayIndex] = useState(0);
  const [selectedTimeIndex, setSelectedTimeIndex] = useState(0);
  const [selectedKey, setSelectedKey] = useState<string | null>(null);



  const handleEventSelect = (selectedId: string) => {
    setCurrentPage(1);
    setSearchText("");
    fetchData(selectedId);
  };

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const formattedDate = new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);

    return formattedDate;
  };
  const hasTickets = true;

  // ✅ Helper
  const jsonToUrlParams = (json: any) => {
    const params = new URLSearchParams();
    for (const key in json) {
      if (json.hasOwnProperty(key) && json[key] !== undefined) {
        params.append(key, json[key]);
      }
    }
    return params.toString();
  };
  const handleCloseOffCanvasCatCreate = () => {
    setIsCategoryCreateOffCanvasOpen(false);
  };

  const handleTicketActionSuccess = () => {
    setIsCategoryCreateOffCanvasOpen(false);
    setModalData(null);
    if (dataType === "participants") {
      getDataParticipants();
    } else {
      getDataEventNotifies();
    }
  };

  // ✅ Load events
  const getData = async () => {
    setLoading(true);
    try {
      const data: any = await getALLevent();

      if (data?.data?.data) {
        const eventData = data.data.data;
        setData(eventData);

        const firstEventDetails = eventData[0]?.event_details;
        if (firstEventDetails) {
          setDefaultEventId(firstEventDetails);
          const venueKey = await fetchData(firstEventDetails);
          if (venueKey) {
            await getDataParticipants(firstEventDetails, venueKey);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching event data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async (eventId: any) => {
    try {
      const data: any = await getEventDetails(eventId);
      if (data.data?.status === 100) {
        setId(eventId);

        const eventData = data.data.data;
        setEventData(eventData);
        setVenues(eventData.venues || []);

        if (
          eventData.venues?.length > 0 &&
          eventData.venues[0].days?.length > 0 &&
          eventData.venues[0].days[0].times?.length > 0
        ) {
          const key = eventData.venues[0].days[0].times[0].key;
          setSelectedVenueIndex(0);
          setSelectedDayIndex(0);
          setSelectedTimeIndex(0);
          setSelectedKey(key);

          getEventStatus(eventId, key);
          getVolume(eventId, key);
          return key;
        }

        setSelectedKey(null);
        setPartData([]);
        setDataCount(0);
        toast.error("No venue slot available for this event.");
        return null;
      } else {
        toast.error(data.message || "Getting events failed!");
        return null;
      }
    } catch (err) {
      console.error("Error fetching event:", err);
      toast.error("Failed to fetch event data");
      return null;
    }
  };

  const getApiErrorMessage = (error: any, fallback: string) => {
    return (
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.response?.data?.data?.message ||
      fallback
    );
  };

  // ✅ Tickets + Participants
  const getDataParticipants = async (overrideEventId?: string, overrideVenueKey?: string | null) => {
    const activeEventId = overrideEventId || eventId;
    const activeVenueKey = overrideVenueKey ?? selectedKey;
    if (!activeEventId) return;
    if (!activeVenueKey) {
      // Backend requires venue_key — skip until a slot is selected
      return;
    }

    try {
      const params: any = {
        page: currentPage || 1,
        limit: itemsPerPage || 10,
        id: activeEventId,
        search_text: searchText.trim(),
        venue_key: activeVenueKey,
        ...filterParams,
      };

      const data = await getPartiDetails(jsonToUrlParams(params));
      if (data?.data?.status === 200) {
        setPartData(data.data.data);
        setDataCount(data.data["count"] || 0);
      } else {
        toast.error(data?.data?.message || data?.data?.error || "Failed to fetch participants!");
      }
    } catch (error) {
      toast.error(getApiErrorMessage(error, "An error occurred while fetching participants."));
    }
  };

  const getEventTicket = async () => {
    if (!eventId) return;
    try {
      let params: any = { event_id: eventId };
      if (selectedKey) params.venue_key = selectedKey;

      const data = await getTickent(jsonToUrlParams(params));
      if (data?.data?.status === 100) {
        setEventDetails(data.data.data);
      } else {
        toast.error(data?.data?.message || "Failed to fetch ticket!");
      }
    } catch (error) {
      toast.error("An error occurred while fetching ticket.");
    }
  };

  const getEventStatus = async (id: any, key?: string | null) => {
    if (!id) return;

    try {
      let params: any = { event_id: id };
      if (key) params.venue_key = key;

      const data = await getEventS(jsonToUrlParams(params));
      if (data?.data?.status === 100) {
        setTicketStatus(data.data.data);
      } else {
        toast.error(data?.data?.message || "Failed to fetch status!");
      }
    } catch (error) {
      toast.error("An error occurred while fetching status.");
    }
  };

  const getVolume = async (eventId: any, key?: string | null) => {
    if (!eventId) return;

    try {
      let params: any = { id: eventId };
      if (key) params.venue_key = key;

      const data: any = await geteventVolume(jsonToUrlParams(params));
      if (data.data?.status === 100) {
        setVolume(data.data.data);
      } else {
        toast.error("Getting events failed!");
      }
    } catch (error) {
      toast.error("Error fetching event volume!");
    }
  };

  useEffect(() => {
    if (selectedKey) {
      // getDataParticipants();
      getEventTicket();
      getVolume(eventId, selectedKey);
      getEventStatus(eventId, selectedKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKey]);

  useEffect(() => {
    if (!eventId) return;
    // Participants API requires venue_key — wait until a slot is selected
    if (dataType === "participants" && !selectedKey) return;

    const delayDebounceFn = setTimeout(() => {
      if (dataType === "participants") {
        getDataParticipants();
      } else {
        getDataEventNotifies();
      }
    }, 400);

    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKey, currentPage, dataType, eventId, searchText]);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleRefresh = async () => {
    if (!eventId) {
      toast.error("Please select an event first.");
      return;
    }
    if (dataType === "participants" && !selectedKey) {
      toast.error("Please select a venue/time slot first.");
      return;
    }

    setIsRefreshing(true);
    try {
      if (dataType === "participants") {
        await getDataParticipants();
      } else {
        await getDataEventNotifies();
      }
    } finally {
      setIsRefreshing(false);
    }
  };

  const getDataEventNotifies = async (overrideEventId?: string) => {
    const activeEventId = overrideEventId || eventId;
    if (!activeEventId) return;

    try {
      const params = {
        page: currentPage || 1,
        limit: itemsPerPage || 10,
        event_details: activeEventId,
        search_text: searchText.trim(),
        ...filterParams,
      };

      const data = await getNotifiesDetails(jsonToUrlParams(params));

      if (data?.data?.status === 200) {
        setNotifies(data.data.data);
        setDataCount(data.data["count"] || 0);
      } else {
        toast.error(data?.data?.message || "Failed to fetch participants!");
      }
    } catch (error) {
      toast.error("An error occurred while fetching participants.");
    }
  };


  const handleOpenOffCanvasCatCreate = async (transactionReference: string, rowData?: any) => {
    if (!transactionReference) {
      console.error("Transaction ID is missing.");
      toast.error("Transaction ID is required.");
      return;
    }
    try {
      console.log("Fetching details for ID:", transactionReference);

      const params = {
        event_id: eventId,
        transaction_id: transactionReference,
      };

      const response = await getDetailsById(jsonToUrlParams(params));
      if (response?.data?.status === 200) {
        console.log("Data fetched successfully:", response.data.data);
        setModalData({
          ...response.data.data,
          transaction_reference:
            response.data.data?.transaction_reference || transactionReference,
          row_transaction_id: rowData?.id,
          row_transaction_reference: transactionReference,
          row_is_refund: rowData?.is_refund,
          row_is_refund_init: rowData?.is_refund_init,
          row_is_refund_rejected: rowData?.is_refund_rejected,
          row_is_refund_request_approved: rowData?.is_refund_request_approved,
          row_refund_request_status: rowData?.refund_request_status,
        });
        setIsCategoryCreateOffCanvasOpen(true);
      } else {
        console.error(
          "Error:",
          response?.data?.message || "Failed to fetch details."
        );
        toast.error(
          response?.data?.message || "An error occurred while fetching details."
        );
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };
  const handleVenueSelect = (vi: number) => {
    setSelectedVenueIndex(vi);
    setSelectedDayIndex(0);
    setSelectedTimeIndex(0);

    const key = venues[vi]?.days?.[0]?.times?.[0]?.key || null;
    setSelectedKey(key); // ✅ triggers useEffect to fetch data
  };

  const handleDaySelect = (di: number) => {
    setSelectedDayIndex(di);
    setSelectedTimeIndex(0);

    const key = venues[selectedVenueIndex]?.days?.[di]?.times?.[0]?.key || null;
    setSelectedKey(key); // ✅ triggers useEffect to fetch data
  };

  const handleTimeSelect = (ti: number) => {
    setSelectedTimeIndex(ti);

    const key =
      venues[selectedVenueIndex]?.days?.[selectedDayIndex]?.times?.[ti]?.key ||
      null;
    setSelectedKey(key); // ✅ triggers useEffect to fetch data
  };


  if (loading) {
    return (
      <div className="dashboard-loading">
        <div className="dashboard-loading__spinner" />
        <span>Loading dashboard...</span>
      </div>
    );
  }
  if (!eventData && !loading) {
    return (
      <div className="dashboard-loading">
        <span>Event not available</span>
      </div>
    );
  }

  const parseTicketValue = (value: string): number => {
    return parseInt(value, 10) || 0;
  };
  // download report
  const handleDownload = async () => {
    setLoading(true); // Set loading to true before starting the data fetch
    try {
      await download(eventId);
    } catch (error) {
      console.error("Error fetching event data:", error);
    } finally {
      setLoading(false); // Set loading to false after data fetch is complete
    }
  };

  const handleNotifyReportDownload = async () => {
    setLoading(true); // Set loading to true before starting the data fetch
    try {
      await downloadNotifyReport(eventId);
    } catch (error) {
      console.error("Error fetching event data:", error);
    } finally {
      setLoading(false); // Set loading to false after data fetch is complete
    }
  };
  const notifyHeaders = [
    "SERIAL NUMBER",
    "FIRST NAME",
    "LAST NAME",
    "EMAIL ADDRESS",
    "CONTACT NUMBER",
    "DATE/ TIME",
  ];

  const renderRowNotifies = (item: any, index: number) => (
    <tr key={index} style={{ borderTop: "hidden" }} className="mt">
      <td className="inventory_td">{currentPage > 1 ? dataCount - ((currentPage - 1) * 10) - index : dataCount - index}</td>
      <td className="inventory_td">{item.first_name}</td>
      <td className="inventory_td">{item.last_name}</td>
      <td className="inventory_td">{item.email}</td>
      <td className="inventory_td">{item.phone_number}</td>
      <td className="inventory_td">
        {new Date(item.created_at).toLocaleString()}
      </td>
    </tr>
  );

  const participantHeaders = [
    "TICKET REFERENCE",
    "DATE/TIME",
    "NAME",
    "EMAIL",
    "STATUS",
    "REFUND STATUS",
    "PAID AMOUNT",
    "ACTIONS",
  ];

  const getRefundStatusMeta = (item: any) => {
    if (item?.is_refund) {
      return { label: "Refunded", className: "status-badge--refunded" };
    }

    if (
      item?.refund_request_status === "refund-rejected" ||
      item?.refund_request_status === "rejected" ||
      item?.is_refund_rejected
    ) {
      return { label: "Refund Rejected", className: "status-badge--refund-rejected" };
    }

    if (item?.refund_request_status === "refund-initiated" || item?.is_refund_init) {
      return { label: "Refund Initiated", className: "status-badge--refund-initiated" };
    }

    return { label: "Not Refunded", className: "status-badge--not-refunded" };
  };

  const renderRowParticipants = (item: any, index: number) => (
    <tr key={index} className="data-table__row">
      <td className="inventory_td inventory_td--ref">
        <span className="cell-ref">{item.transaction_reference}</span>
      </td>
      <td className="inventory_td inventory_td--date">
        {new Date(item.datetime).toLocaleString()}
      </td>
      <td className="inventory_td inventory_td--name">{item.customer_name}</td>
      <td className="inventory_td inventory_td--email">{item.customer_email}</td>
      <td className="inventory_td">
        <span
          className={`status-badge ${
            item.is_refund ? "status-badge--refund" : "status-badge--paid"
          }`}
        >
          {item.is_refund ? "Refund" : "Paid"}
        </span>
      </td>
      <td className="inventory_td">
        <span
          className={`status-badge ${getRefundStatusMeta(item).className}`}
        >
          {getRefundStatusMeta(item).label}
        </span>
      </td>
      <td className="inventory_td inventory_td--amount">
        <div className="paid-amount-cell">
          <span className="paid-amount-cell__value">
            {Number(item.total_amount).toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            LKR
          </span>
          {item.has_ticket_upgrade && (
            <span
              className="amount-mark amount-mark--upgrade"
              title="Ticket upgraded"
              aria-label="Ticket upgraded"
            >
              ↑
            </span>
          )}
          {item.has_ticket_cancellation && (
            <span
              className="amount-mark amount-mark--cancel"
              title="Ticket cancelled"
              aria-label="Ticket cancelled"
            >
              ×
            </span>
          )}
        </div>
      </td>
      <td className="inventory_td inventory_td--actions">
        <div className="row-actions">
          <span
            className={`check_in ${
              item.is_checked_in ? "check_in--success" : "check_in--pending"
            }`}
          >
            {item.is_checked_in ? "Checked in" : "Check in pending"}
          </span>
          <button
            type="button"
            className="check_icon"
            aria-label="View transaction details"
            onClick={() => {
              handleOpenOffCanvasCatCreate(item.transaction_reference, item);
            }}
          >
            <IoEyeOutline />
          </button>
        </div>
      </td>
    </tr>
  );

  // Helper function to normalize image URL
  // Helper function to normalize image URL
  const getImageUrl = (baseUrl: string, imagePath: string) => {
    console.log('getImageUrl called with:', { baseUrl, imagePath });

    if (!imagePath) {
      console.log('No image path provided');
      return '';
    }

    // Remove trailing slash from baseUrl if present
    const cleanBaseUrl = baseUrl.replace(/\/$/, '');

    // Ensure imagePath starts with a slash
    const cleanImagePath = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
    const finalUrl = `${cleanBaseUrl}${cleanImagePath}`;

    console.log('Final URL:', finalUrl);
    return finalUrl;
  };

  return (
    // <div></div>
    <div className="main">
      <div className="container mt-3">
        <div className="dashboard-header">
          <h3 className="dashboard-header__title">Event ticket dashboard</h3>
          <div className="dashboard-header__controls">
            <SearchableEventSelect
              events={event}
              selectedEventId={eventId || defaultEventId}
              onSelect={handleEventSelect}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-6">
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-6 responsive_tab">
                <div className="menu_itam">

                  <p className="dh-count mt-3">
                    {" "}
                    {volume &&
                      volume.total_tickets &&
                      !isNaN(volume.total_tickets)
                      ? volume.total_tickets
                      : "0"}
                  </p>
                  <p className="dh-sub-description mt-3">
                    Number of Ticket Sale
                  </p>
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6 responsive_tab">
                <div className="menu_itam2">

                  <p className="dh-count2 mt-3">
                    {volume && volume.total_amount && !isNaN(volume.total_amount)
                      ? Number(volume.total_amount).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                      : "0.00"}
                    <span className="dh-currency">
                      {eventData && eventData.tickets_currency
                        ? eventData.tickets_currency
                        : "N/A"}
                    </span>
                  </p>


                  <p className="dh-sub-description2 mt-3">Total Ticket Sale</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6">
            <div className="menu_itam3">
              <div className="row">
                <div className="col-sm-12 col-md-8 col-lg-8">
                  <div className="event_d_grid">
                    <h3 className="event_d">
                      Event Name :
                      <span className="event_d_data">
                        {eventData.event_name || "N/A"}
                      </span>
                    </h3>
                    <div className="border_line mt-3 mb-3"></div>
                    <div className="row mb-4">
                      <div className="col-6">
                        <div className="section_d">
                          <p className="dh_data_head">Currency</p>
                          <p className="dh_data">
                            {eventData.tickets_currency || "N/A"}
                            {/* {formatDate(eventData.event_datetime) || "N/A"} */}
                          </p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="section_d">
                          <p className="dh_data_head">Event Expire Date</p>
                          <p className="dh_data">
                            {formatDate(eventData.event_expire_on) || "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div className="col-6">
                        <div className="section_d">
                          <p className="dh_data_head">Venue</p>
                          <p className="dh_data">{eventData.venue || "N/A"}</p>
                        </div>
                      </div>
                      <div className="col-6">
                        <div className="section_d">
                          <p className="dh_data_head">Currency</p>
                          <p className="dh_data">
                            {eventData.tickets_currency || "N/A"}
                          </p>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>


               
                {/* <div className="col-sm-12 col-md-4 col-lg-4 image_hide">
                  <img
                    style={{
                      width: "100%",
                      height: "auto",
                    }}
                    className="img"
                    src={getImageUrl(environment.aws, eventData.event_banner)}
                    alt="banner"
                  />
                </div> */}


                <div className="col-sm-12 col-md-4 col-lg-4 image_hide new-image">
                  <div className="image-resize-container">
                    <img
                      className="image-resize"
                      src={getImageUrl(environment.aws, eventData?.event_banner)}
                      alt="banner"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>



        </div>

        <h3 className="event_name_sub mt-3 mb-3">Event tickets</h3>

        <div className="event-tickets-toolbar">
          <div className="event-tickets-toolbar__schedule venue-selection">
            {!venues || venues.length === 0 ? (
              <div className="venue-selection__empty">
                <EmptyState
                  icon="calendar"
                  title="No schedule configured"
                  subtitle="Venue, day, and time details will appear here once your event is set up"
                />
              </div>
            ) : (
              <div className="venue-selection__content">
                <div className="venue-filter-row">
                  <div className="venues d-flex flex-row flex-nowrap overflow-auto">
                    {venues.map((venue, vi) => (
                      <button
                        key={vi}
                        type="button"
                        className={`${selectedVenueIndex === vi ? "test_btn" : "test_btn_non"}`}
                        onClick={() => handleVenueSelect(vi)}
                      >
                        {venue.venue}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="venue-filter-row">
                  {venues[selectedVenueIndex]?.days?.length > 0 ? (
                    <div className="days d-flex flex-row flex-nowrap overflow-auto">
                      {venues[selectedVenueIndex].days.map((day: any, di: any) => (
                        <button
                          key={di}
                          type="button"
                          className={`${selectedDayIndex === di ? "test_btn" : "test_btn_non"}`}
                          onClick={() => handleDaySelect(di)}
                        >
                          {day.day}
                        </button>
                      ))}
                    </div>
                  ) : (
                    <span className="filter-placeholder">No days configured for this venue</span>
                  )}
                </div>

                <div className="venue-filter-row">
                  {venues[selectedVenueIndex]?.days?.[selectedDayIndex]?.times?.length > 0 ? (
                    <div className="times d-flex flex-row flex-nowrap overflow-auto">
                      {venues[selectedVenueIndex].days[selectedDayIndex].times.map(
                        (time: any, ti: any) => (
                          <button
                            key={ti}
                            type="button"
                            className={`${selectedTimeIndex === ti ? "test_btn" : "test_btn_non"}`}
                            onClick={() => handleTimeSelect(ti)}
                          >
                            {time.start_time} - {time.end_time}
                          </button>
                        )
                      )}
                    </div>
                  ) : (
                    <span className="filter-placeholder">No times configured for this day</span>
                  )}
                </div>
              </div>
            )}
          </div>

          <div className="event-tickets-toolbar__stats">
            <div className="menu_itam_location">
              <p className="dh-count_location">
                {volume &&
                  volume.venue_total_tickets &&
                  !isNaN(volume.venue_total_tickets)
                  ? volume.venue_total_tickets
                  : "0"}
              </p>
              <p className="location_count_name">Total Ticket Sale</p>
              <p className="location_count_data">
                <span>{venues[selectedVenueIndex]?.venue || "N/A"}</span>
                <span className="location_count_data__sep">|</span>
                <span>
                  {venues[selectedVenueIndex]?.days?.[selectedDayIndex]?.times?.[selectedTimeIndex]
                    ?.start_time || "N/A"}
                </span>
              </p>
            </div>

            <div className="menu_itam_location">
              <p className="dh-count_location">
                {volume &&
                  volume.venue_total_amount &&
                  !isNaN(volume.venue_total_amount)
                  ? Number(volume.venue_total_amount).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  : "0.00"}
                <span className="location-currency">
                  {eventData && eventData.tickets_currency
                    ? eventData.tickets_currency
                    : "N/A"}
                </span>
              </p>
              <p className="location_count_name">Net amount</p>
              <p className="location_count_data">
                <span>{venues[selectedVenueIndex]?.venue || "N/A"}</span>
                <span className="location_count_data__sep">|</span>
                <span>
                  {venues[selectedVenueIndex]?.days?.[selectedDayIndex]?.times?.[selectedTimeIndex]
                    ?.start_time || "N/A"}
                </span>
              </p>
            </div>
          </div>
        </div>














        <div className="dh_summary_section">
          <div className="dh_summary_section__grid">
            <div className="dh_summary_section__table">
              <div className="event_d_grid2">
                <div className="row">
                  <div className="col-20">
                    <div className="section_d">
                      <p
                        className="dh_data_head event_ticket_name"

                      >
                        Ticket Name
                      </p>
                    </div>
                  </div>
                  <div className="col-20">
                    <div className="section_d">
                      <p className="dh_data_head event_ticket_name">
                        Total Tickets
                      </p>
                    </div>
                  </div>
                  <div className="col-20">
                    <div className="section_d">
                      <p className="dh_data_head event_ticket_name">
                        Remaining Tickets
                      </p>
                    </div>
                  </div>
                  <div className="col-20">
                    <div className="section_d">
                      <p className="dh_data_head event_ticket_name">
                        Display Price
                      </p>
                    </div>
                  </div>
                  <div className="col-20">
                    <div className="section_d">
                      <p className="dh_data_head event_ticket_name">
                        Tickets Availability
                      </p>
                    </div>
                  </div>

                </div>



                {/* 
                {hasTickets ? (
                  data.map((ticket) => (
                    <React.Fragment key={ticket.id}>
                      <div className="row">
                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">{ticket.ticket_name}</p>
                          </div>
                        </div>
                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">{ticket.total_tickets}</p>
                          </div>
                        </div>

                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">
                              {ticket.remaining_tickets}
                            </p>
                          </div>
                        </div>


                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">{ticket.ticket_amount}</p>
                          </div>
                        </div>

                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">
                              {ticket ? (
                                ticket.is_delete ? (
                                  <span className="deleted">Deleted</span>
                                ) : ticket.is_active ? (
                                  ticket.is_sold_out ? (
                                    <span className="sold-out">Sold Out</span>
                                  ) : (
                                    <span className="available">Available</span>
                                  )
                                ) : (
                                  <span className="inactive">Inactive</span>
                                )
                              ) : (
                                <span className="no-data">No Ticket Data</span>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="line_summary_table mt-3 mb-3"></div>
                    </React.Fragment>
                  ))
                ) : (
                  <p>No tickets available at the moment.</p>
                )} */}
                {hasTickets && tickets && tickets.length > 0 ? (
                  tickets.map((ticket) => (
                    <React.Fragment key={ticket?.id || Math.random()}>
                      <div className="row">
                        {/* Ticket Name */}
                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">{ticket?.ticket_name || "N/A"}</p>
                          </div>
                        </div>

                        {/* Total Tickets */}
                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">
                              {ticket?.total_tickets
                                ? Number(ticket.total_tickets).toFixed(0) // removes decimals
                                : "0"}
                            </p>
                          </div>
                        </div>

                        {/* Remaining Tickets */}
                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">
                              {ticket?.total_tickets
                                ? Number(ticket.remaining_tickets).toFixed(0) // removes decimals
                                : "0"}
                            </p>

                          </div>
                        </div>

                        {/* Ticket Amount */}
                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">
                              {ticket?.ticket_amount != null ? ticket.ticket_amount : "N/A"}   {eventData && eventData.tickets_currency
                                ? eventData.tickets_currency
                                : "N/A"}

                            </p>
                          </div>
                        </div>

                        {/* Status */}
                        <div className="col-20">
                          <div className="section_d">
                            <p className="dh_data">
                              {ticket ? (
                                ticket.is_delete ? (
                                  <span className="deleted">Deleted</span>
                                ) : ticket.is_active ? (
                                  ticket.is_sold_out ? (
                                    <span className="sold-out">Sold Out</span>
                                  ) : (
                                    <span className="available">Available</span>
                                  )
                                ) : (
                                  <span className="inactive">InActive</span>
                                )
                              ) : (
                                <span className="no-data">No Ticket Data</span>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="line_summary_table mt-3 mb-3"></div>
                    </React.Fragment>
                  ))
                ) : (
                  <EmptyState
                    inline
                    icon="ticket"
                    title="No tickets available"
                    subtitle="Ticket details will appear here once configured"
                  />
                )}




















              </div>
            </div>
            <div className="dh_summary_section__stats">
              {hasTickets ? (
                <div className="checkin-stats-grid">
                  {tStatus && tStatus.length > 0 ? (
                    tStatus.map((ticket:any) => (
                      <div key={ticket.id} className="checkin-stat-card box_grid">
                        <p className="box_name">{ticket.name}</p>
                        <h4 className="box_data_1">
                          {parseTicketValue(ticket.checked_in_ticket_count)}
                          <span className="box_data_2">
                            /{parseTicketValue(ticket.purchased_ticket_count)}
                          </span>
                        </h4>
                      </div>
                    ))
                  ) : (
                    <div className="checkin-stat-card checkin-stat-card--empty box_grid">
                      <EmptyState
                        icon="ticket"
                        title="No tickets available"
                        subtitle="Check-in stats will appear here once tickets are sold"
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div className="checkin-stats-grid">
                  <div className="checkin-stat-card box_grid update_grid">
                    <p className="box_name">No Data</p>
                    <h4 className="box_data_1">
                      --<span className="box_data_2">/--</span>
                    </h4>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="row mb-2 mt-4">
          <div className="col d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <h3
                className={`${dataType === "participants"
                  ? "select_event_name_sub"
                  : "unselect_event_name_sub"
                  }`}
                onClick={() => {
                  setCurrentPage(1);
                  setDataType("participants");
                }}
              >
                Participants List{" "}
              </h3>
              <h3
                className={`${dataType === "notifies"
                  ? "select_event_name_sub"
                  : "unselect_event_name_sub"
                  }`}
                onClick={() => {
                  setCurrentPage(1);
                  setDataType("notifies");
                }}
              >
                Notify Me{" "}
              </h3>
            </div>

            <div className="participants-toolbar__actions">
              <div className="participants-search">
                <input
                  type="search"
                  className="participants-search__input"
                  placeholder={
                    dataType === "participants"
                      ? "Search by name or email..."
                      : "Search notify me by name or email..."
                  }
                  value={searchText}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearchText(e.target.value);
                  }}
                  aria-label="Search participants"
                />
              </div>
              <button
                type="button"
                className="refresh-btn"
                onClick={handleRefresh}
                disabled={isRefreshing || !eventId}
                aria-label="Refresh list"
              >
                <IoRefresh className={isRefreshing ? "refresh-btn__icon--spinning" : ""} />
                <span>{isRefreshing ? "Refreshing..." : "Refresh"}</span>
              </button>
              {dataCount > 0 && (
                <button
                  type="button"
                  className="download-btn"
                  onClick={dataType === 'participants' ? handleDownload : handleNotifyReportDownload}
                >
                  <CgSoftwareDownload />
                  <span>Download Reports</span>
                </button>
              )}
            </div>
          </div>
        </div>



        {dataType === "participants" ? (
          <ReusableTable
            headers={participantHeaders}
            rows={partData}
            dataCount={dataCount}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            renderRow={renderRowParticipants}
          />
        ) : (
          <ReusableTable
            headers={notifyHeaders}
            rows={notifies}
            dataCount={dataCount}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
            renderRow={renderRowNotifies}
          />
        )}
      </div>
      {isCategoryCreateOffCanvasOpen && (
        <CreateCategory
          headline="test"
          onClose={handleCloseOffCanvasCatCreate}
          viewData={modalData}
          eventTickets={tickets}
          onRetry={handleOpenOffCanvasCatCreate}
          onActionSuccess={handleTicketActionSuccess}
        />
      )}
    </div>
  );
}

export default Dashbord;
